import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useUtilizationHeatmapStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
  },
  legend: {
    display: 'flex',
    ...shorthands.gap(tokens.spacingHorizontalM),
    flexWrap: 'wrap',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
  },
  legendSwatch: {
    width: '12px',
    height: '12px',
    ...shorthands.borderRadius('2px'),
  },
  legendLabel: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground2,
  },
});
